import { getTotalSteps } from "./store";

export function resetFormFields() {
  const signupForm = document.getElementById("signupForm") as HTMLFormElement;
  const inputs = signupForm.querySelectorAll("input");
  inputs.forEach((input) => {
    input.classList.remove("border-red-500");
    const errorMessage = input.parentElement?.querySelector(".error-message");
    if (errorMessage) errorMessage.remove();
  });
}

// Show a modal with a message
export function showModal(
  message: string,
  type: "error" | "success" = "error",
  duration = 0
): void {
  const modal = document.createElement("div");
  modal.className =
    "fixed inset-0 bg-gray-900/50 backdrop-blur-sm flex items-center justify-center z-[150]";

  const icon =
    type === "error"
      ? `<svg class="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
           <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
         </svg>`
      : `<svg class="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
           <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
         </svg>`;

  modal.innerHTML = `
    <div class="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-4">
      <div class="flex items-center space-x-4 mb-4">${icon}
        <p class="text-gray-700 flex-1">${message}</p>
      </div>
      <div class="flex justify-end">
        <button 
          class="px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark transition-colors"
          onclick="this.closest('.fixed')?.remove()"
        >
          OK
        </button>
      </div>
    </div>`;

  document.body.appendChild(modal);

  if (duration > 0) {
    setTimeout(() => modal.remove(), duration);
  }
}

// Update the progress bar
export function updateProgressBar(currentStep: number): void {
  const progressBar = document.getElementById("progressBar") as HTMLElement;
  const progressText = document.getElementById("progressText") as HTMLElement;

  // Aggiorna il testo del contatore
  progressText.textContent = `${currentStep} / ${getTotalSteps()}`;

  // Aggiorna la barra di avanzamento
  const progressPercentage = (currentStep / getTotalSteps()) * 100;
  progressBar.style.width = `${progressPercentage}%`;
}

export function showLoader(): void {
  const loaderOverlay = document.getElementById("loaderOverlay") as HTMLElement;
  loaderOverlay.style.display = "flex";
}

export function hideLoader(): void {
  const loaderOverlay = document.getElementById("loaderOverlay") as HTMLElement;
  loaderOverlay.style.display = "none";
}
